import {createFileRoute, redirect} from '@tanstack/react-router'
import getPreferredLocale from '~/client/fn/locale'

export const Route = createFileRoute('/')({
    beforeLoad: async () => {
        const locale = await getPreferredLocale()
        return redirect({
            to: '/$lang',
            params: {
                lang: locale.split('_')[0] ?? 'en',
            },
        })
    },
})
